(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dze-accessory-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dze-label-purchase')) {
  customElements.define('dze-label-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const select = this.querySelector('[data-label-variant]');
      if (!select) return;
      const update = () => {
        const option = select.selectedOptions[0];
        const button = this.querySelector('[data-dze-add-to-cart]');
        const quantity = this.querySelector('[name="quantity"]');
        this.querySelector('.accessory-product__price').textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldOutLabel : button.dataset.addLabel;
        if (option.dataset.tracked === 'true' && Number(option.dataset.quantity) > 0) {
          quantity.max = option.dataset.quantity;
          quantity.value = Math.max(1, Math.min(Number(quantity.value) || 1, Number(quantity.max)));
        } else quantity.removeAttribute('max');
      };
      select.addEventListener('change', update, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

if (!customElements.get('dze-accessory-gallery')) {
  customElements.define('dze-accessory-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.accessory-gallery__track');
      this.slides = [...this.querySelectorAll('.accessory-gallery__slide')];
      this.dots = [...this.querySelectorAll('[data-gallery-index]')];
      this.dialog = this.querySelector('.accessory-lightbox');
      this.current = 0;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.querySelector('.accessory-gallery__dots').hidden = this.slides.length < 2;
      const arrows = this.querySelector('.accessory-gallery__arrows');
      if (arrows) arrows.hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-gallery-index')) this.go(Number(button.dataset.galleryIndex));
        if (button.hasAttribute('data-gallery-prev')) this.go(this.current - 1);
        if (button.hasAttribute('data-gallery-next')) this.go(this.current + 1);
        if (button.hasAttribute('data-gallery-open') && (!event.detail || !this.dragged)) this.openImage(Number(button.dataset.galleryOpen), button);
        if (button.hasAttribute('data-gallery-close')) this.dialog.close();
        if (button.hasAttribute('data-lightbox-prev')) this.showImage(this.lightboxIndex - 1);
        if (button.hasAttribute('data-lightbox-next')) this.showImage(this.lightboxIndex + 1);
      }, options);
      this.track.addEventListener('pointerdown', event => {
        this.dragged = false;
        this.pointerStart = { x: event.clientX, y: event.clientY, left: this.track.scrollLeft };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 8) this.dragged = true;
      }, options);
      this.track.addEventListener('pointercancel', () => { this.dragged = true; }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('keydown', event => {
        if (!this.dialog.open) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showImage(this.lightboxIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        this.go(this.lightboxIndex, 'instant');
        this.opener?.focus({ preventScroll: true });
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.pointerStart && Math.abs(this.track.scrollLeft - this.pointerStart.left) > 8) this.dragged = true;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.go(this.current, 'instant'));
      this.resize.observe(this.track);
      this.lightboxResize = new ResizeObserver(() => {
        if (this.dialog.open && this.lightboxTrack) this.showImage(this.lightboxIndex, 'instant');
      });
      this.lightboxResize.observe(this.dialog.querySelector('.accessory-lightbox__stage'));
      this.update();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow;
      }
      this.listeners?.abort();
      this.resize?.disconnect();
      this.lightboxResize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    openImage(index, opener) {
      this.opener = opener;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.showImage(index, 'instant');
      this.querySelector('[data-gallery-close]').focus();
    }
    showImage(index, behavior) {
      this.lightboxIndex = Math.max(0, Math.min(this.slides.length - 1, index));
      if (!this.lightboxTrack) {
        this.lightboxTrack = document.createElement('div');
        this.lightboxTrack.className = 'accessory-lightbox__track';
        this.lightboxSlides = this.slides.map(slide => {
          const source = slide.querySelector('[data-full-image]');
          const item = document.createElement('div');
          item.className = 'accessory-lightbox__slide';
          const image = document.createElement('img');
          image.className = 'accessory-lightbox__image';
          image.alt = source.querySelector('img').alt;
          image.dataset.src = source.dataset.fullImage;
          image.decoding = 'async';
          item.append(image);
          this.lightboxTrack.append(item);
          return item;
        });
        this.dialog.querySelector('.accessory-lightbox__stage').replaceChildren(this.lightboxTrack);
      }
      this.lightboxSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== this.lightboxIndex));
        if (Math.abs(slideIndex - this.lightboxIndex) <= 1) {
          const image = slide.querySelector('img');
          if (!image.getAttribute('src')) image.src = image.dataset.src;
        }
      });
      this.lightboxTrack.scrollTo({
        left: this.lightboxIndex * this.lightboxTrack.clientWidth,
        behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth')
      });
      this.dialog.querySelector('.accessory-lightbox__count').textContent = `${this.lightboxIndex + 1} / ${this.slides.length}`;
      this.dialog.querySelector('[data-lightbox-prev]').disabled = this.lightboxIndex === 0;
      this.dialog.querySelector('[data-lightbox-next]').disabled = this.lightboxIndex === this.slides.length - 1;
      this.dialog.querySelector('.accessory-lightbox__controls').hidden = this.slides.length < 2;
    }
    go(index, behavior) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      const slide = this.slides[index];
      const left = this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
    }
    update() {
      const left = this.track.getBoundingClientRect().left;
      this.current = this.slides.reduce((best, slide, index) =>
        Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
      this.dots.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.current)));
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (previous) previous.disabled = this.current === 0;
      if (next) next.disabled = this.current === this.slides.length - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-albums"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('.dze-albums__toggle');
  if (!button) return;
  const panel = document.getElementById(button.getAttribute('aria-controls'));
  if (!panel) return;
  panel.hidden = !panel.hidden;
  button.closest('.dze-albums').querySelectorAll('.dze-albums__toggle').forEach((control) => {
    if (control.getAttribute('aria-controls') === panel.id) control.setAttribute('aria-expanded', String(!panel.hidden));
  });
});
document.addEventListener('shopify:block:select', (event) => {
  const button = event.target.matches('.dze-albums__toggle') ? event.target : event.target.querySelector('.dze-albums__toggle');
  if (button && button.getAttribute('aria-expanded') === 'false') button.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-directory"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){var opener=event.target.closest('[data-dze-directory-open]');if(opener){var dialog=document.getElementById(opener.getAttribute('data-dze-directory-open'));if(dialog)dialog.showModal()}if(event.target.closest('[data-dze-directory-close]'))event.target.closest('dialog').close();if(event.target.tagName==='DIALOG')event.target.close()});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-dze-back-to-top]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'instant' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-home-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const init = () => {
      document.querySelectorAll('[data-dze-home-carousel]').forEach((root) => {
        if (root.dataset.carouselReady) return;
        const row = root.querySelector('.dze-content__grid-3');
        const controls = root.querySelector('[data-carousel-controls]');
        if (!row || !controls) return;
        root.dataset.carouselReady = 'true';
        const previous = controls.querySelector('[data-carousel-direction="-1"]');
        const next = controls.querySelector('[data-carousel-direction="1"]');
        const update = () => {
          const max = row.scrollWidth - row.clientWidth;
          controls.hidden = !mobile.matches || max <= 2;
          const heading = root.querySelector('.dze-home-content-section__heading') || row.querySelector('.dze-content__grid-header');
          const top = heading ? heading.getBoundingClientRect().top - root.getBoundingClientRect().top + (heading.offsetHeight - controls.offsetHeight) / 2 : row.offsetTop - 28;
          controls.style.top = `${top}px`;
          previous.disabled = row.scrollLeft <= 2;
          next.disabled = row.scrollLeft >= max - 2;
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          const card = row.querySelector('.dze-content__grid-item');
          const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : row.clientWidth;
          row.scrollBy({ left: Number(button.dataset.carouselDirection) * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
        row.addEventListener('scroll', update, { passive: true });
        row.addEventListener('load', update, true);
        mobile.addEventListener('change', update);
        new ResizeObserver(update).observe(row);
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dze-newsletter-popup')) {
    customElements.define('dze-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.ready) return;
        this.ready = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelector('[data-newsletter-close]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.close();
        }, options);
        const feedback = this.querySelector('[data-newsletter-feedback]');
        if (window.Shopify?.designMode) {
          if (this.hasAttribute('data-preview')) this.show();
          return;
        }
        if (feedback?.dataset.success === 'true') {
          this.rememberSubscription();
          this.show();
          return;
        }
        if (feedback?.dataset.errors === 'true') { this.show(); return; }
        this.footerObserver = new MutationObserver(() => this.checkFooterSubscription());
        document.querySelectorAll('[data-dze-newsletter-result]').forEach(result => this.footerObserver.observe(result, { attributes: true, attributeFilter: ['data-success'] }));
        this.checkFooterSubscription();
        if (this.suppressed()) return;
        this.timer = setTimeout(() => this.tryShow(), Number(this.dataset.delay) * 1000);
        document.addEventListener('visibilitychange', () => {
          if (this.waiting && document.visibilityState === 'visible') this.tryShow();
        }, options);
      }
      read(key) {
        try { const value = localStorage.getItem(key); if (value) return value; } catch {}
        try { return sessionStorage.getItem(key); } catch { return null; }
      }
      write(key, value) {
        try { localStorage.setItem(key, value); } catch {}
        try { sessionStorage.setItem(key, value); } catch {}
      }
      suppressed() {
        const dismissed = Number(this.read('dze-newsletter-dismissed-at')) || 0;
        let shown = false;
        try { shown = sessionStorage.getItem('dze-newsletter-shown') === 'true'; } catch {}
        return this.read('dze-newsletter-subscribed') === 'true' || shown || Date.now() - dismissed < Number(this.dataset.dismissDays) * 86400000;
      }
      rememberSubscription() {
        this.write('dze-newsletter-subscribed', 'true');
        clearTimeout(this.timer);
      }
      checkFooterSubscription() {
        if (document.querySelector('[data-dze-newsletter-result][data-success="true"]')) {
          this.rememberSubscription();
          if (this.dialog.open) this.close();
        }
      }
      tryShow() {
        if (this.suppressed()) return;
        if (document.visibilityState !== 'visible') { this.waiting = true; return; }
        if (document.querySelector('#cart-drawer.is-active, .dze-search-overlay:not([hidden]), #accountPopover.is-active, .dze-menu-overlay.is-active, dialog[open]')) {
          this.timer = setTimeout(() => this.tryShow(), 1000);
          return;
        }
        this.waiting = false;
        this.show();
        try { sessionStorage.setItem('dze-newsletter-shown', 'true'); } catch {}
      }
      show() {
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      close() {
        this.write('dze-newsletter-dismissed-at', String(Date.now()));
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        this.footerObserver?.disconnect();
        if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-policy-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.Shopify?.designMode) return;
  const root = document.querySelector('[data-policy-navigation]');
  const nav = root?.querySelector('.policy-nav');
  if (!nav) return;
  let controller;
  const links = [...nav.querySelectorAll('a[data-policy-page]')];
  const normalize = (url) => new URL(url, location.href).pathname.replace(/\/$/, '');
  const known = (url) => links.some(link => normalize(link.href) === normalize(url));
  const markCurrent = () => links.forEach(link => {
    if (normalize(link.href) === normalize(location.href)) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
  const navigate = async (url, push) => {
    controller?.abort();
    const request = new AbortController();
    controller = request;
    const article = root.querySelector('.policy-article');
    article.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok || !known(response.url)) throw new Error('Page unavailable');
      const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = documentNext.querySelector('[data-policy-navigation] .policy-article');
      if (!content || request.signal.aborted) throw new Error('Content unavailable');
      article.replaceChildren(...content.childNodes);
      document.title = documentNext.title;
      for (const selector of ['link[rel="canonical"]', 'meta[name="description"]']) {
        const next = documentNext.querySelector(selector);
        const current = document.head.querySelector(selector);
        if (next && current) current.replaceWith(next);
        else if (next) document.head.append(next);
        else current?.remove();
      }
      if (push) history.pushState(null, '', url);
      markCurrent();
    } catch (error) {
      if (!request.signal.aborted) location.assign(url);
    } finally {
      if (controller === request) article.removeAttribute('aria-busy');
    }
  };
  nav.addEventListener('click', event => {
    const link = event.target.closest('a[data-policy-page]');
    if (!link || !nav.contains(link) || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    if (url.href !== location.href) navigate(url.href, true);
    else {
      controller?.abort();
      root.querySelector('.policy-article').removeAttribute('aria-busy');
    }
  });
  window.addEventListener('popstate', () => {
    if (known(location.href)) navigate(location.href, false);
    else location.reload();
  });
  markCurrent();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-product-main"] && !Shopify.designMode) return;
  try {
    
function initializeProductLead(root = document) {
  root.querySelectorAll('.dze-product-module--main .dze-product__top').forEach((lead) => {
    if (lead.dataset.equalLead) return;
    lead.dataset.equalLead = 'true';
    const summary = lead.querySelector('.dze-product__summary');
    const image = lead.querySelector('.dze-product__hero img');
    if (!summary || !image) return;
    const update = () => {
      if (window.innerWidth < 750 || !image.naturalWidth) {
        lead.style.removeProperty('--lead-image-width');
        return;
      }
      const gap = parseFloat(getComputedStyle(lead).columnGap) || 16;
      const available = lead.clientWidth - summary.getBoundingClientRect().width - 48 - gap * 3;
      const width = Math.min(available, summary.getBoundingClientRect().height * image.naturalWidth / image.naturalHeight);
      lead.style.setProperty('--lead-image-width', `${Math.max(0, width)}px`);
    };
    const observer = new ResizeObserver(update);
    observer.observe(summary);
    observer.observe(lead);
    image.addEventListener('load', update);
    update();
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(lead)) observer.disconnect();
    });
  });
}
initializeProductLead();
document.addEventListener('shopify:section:load', (event) => initializeProductLead(event.target));

document.addEventListener('play', (event) => {
  if (!event.target.matches('.dze-sound-samples audio')) return;
  document.querySelectorAll('.dze-sound-samples audio').forEach((audio) => {
    if (audio !== event.target) audio.pause();
  });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-program-article"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-program-video-src]');
  if (!button || button.getAttribute('aria-pressed') === 'true') return;
  const player = button.closest('.dze-program-detail__video');
  player.querySelector('iframe').src = button.dataset.programVideoSrc;
  player.querySelectorAll('[data-program-video-src]').forEach((choice) => {
    choice.setAttribute('aria-pressed', String(choice === button));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-programs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dze-program-banner')) {
  customElements.define('dze-program-banner', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.programs-banner__track');
      this.slides = [...this.querySelectorAll('.programs-banner__slide')];
      this.thumbs = [...this.querySelectorAll('[data-banner-index]')];
      this.current = 0;
      this.paused = false;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.querySelector('.programs-banner__arrows').hidden = false;
      this.querySelector('.programs-banner__dots').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-banner-autoplay')) {
          this.paused = !this.paused;
          button.setAttribute('aria-pressed', String(this.paused));
          button.setAttribute('aria-label', this.paused ? 'Resume banner autoplay' : 'Pause banner autoplay');
          button.querySelector('[data-banner-symbol]').setAttribute('d', this.paused ? 'M3 1l8 5-8 5z' : 'M2 1h3v10H2zM7 1h3v10H7z');
        }
        this.startAutoplay();
        if (button.hasAttribute('data-banner-index')) this.go(Number(button.dataset.bannerIndex));
        if (button.hasAttribute('data-banner-step')) this.go(this.current + Number(button.dataset.bannerStep));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('pointerdown', () => clearInterval(this.autoplay), options);
      this.track.addEventListener('pointerup', () => this.startAutoplay(), options);
      this.track.addEventListener('pointercancel', () => this.startAutoplay(), options);
      this.track.addEventListener('pointerleave', () => this.startAutoplay(), options);
      this.resize = new ResizeObserver(() => this.go(this.current, 'instant'));
      this.resize.observe(this.track);
      this.update();
      this.startAutoplay();
    }
    startAutoplay() {
      clearInterval(this.autoplay);
      if (window.Shopify?.designMode || this.paused) return;
      this.autoplay = setInterval(() => {
        const focused = this.contains(document.activeElement) && !document.activeElement.hasAttribute('data-banner-autoplay');
        const hovered = matchMedia('(hover: hover)').matches && this.matches(':hover');
        if (document.hidden || focused || hovered || document.querySelector('dialog[open], #cart-drawer.is-active')) return;
        this.go((this.current + 1) % this.slides.length);
      }, 4000);
    }
    disconnectedCallback() {
      clearInterval(this.autoplay);
      this.listeners?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    go(index, behavior) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      const slide = this.slides[index];
      slide.querySelector('img').loading = 'eager';
      const left = this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
    }
    update() {
      const left = this.track.getBoundingClientRect().left;
      this.current = this.slides.reduce((best, slide, index) =>
        Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
      this.thumbs.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.current)));
      this.querySelector('[data-banner-step="-1"]').disabled = this.current === 0;
      this.querySelector('[data-banner-step="1"]').disabled = this.current === this.slides.length - 1;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dze-sound-map"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sound-map-scroll]');
    if (!button) return;
    var cards = button.parentElement.querySelector('.sound-map-page__cards');
    if (cards) cards.scrollBy({ left: cards.clientWidth * Number(button.dataset.soundMapScroll), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
